import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
import { mergeGoalsIntoProfile, toGoalsPayload } from "./profile.mappers";
import { GoalsPayload, LearningPayload } from "../types/onboarding";

/**
 * Loads existing goals and learning data from user profile
 */
export async function loadGoals(uid: string): Promise<{ goals: GoalsPayload; learning: LearningPayload }> {
  const db = getFirestore();
  const profileRef = doc(db, "profiles", uid);
  
  try {
    const profileSnap = await getDoc(profileRef);
    
    if (profileSnap.exists()) {
      const profileData = profileSnap.data();
      return toGoalsPayload(profileData);
    }
    
    // Return defaults if no profile found
    return {
      goals: {
        categories: ["clients"],
        timeframe: "0-3m"
      },
      learning: {
        topics: []
      }
    };
  } catch (error) {
    console.error("Error loading goals:", error);
    // Return defaults on error
    return {
      goals: {
        categories: ["clients"],
        timeframe: "0-3m"
      },
      learning: {
        topics: []
      }
    };
  }
}

/**
 * Saves goals and learning data to user profile (idempotent merge)
 */
export async function saveGoals(
  uid: string, 
  goals: GoalsPayload, 
  learning: LearningPayload
): Promise<void> {
  const db = getFirestore();
  const profileRef = doc(db, "profiles", uid);
  
  try {
    console.log("🔄 Starting saveGoals for uid:", uid);
    console.log("📊 Goals data:", goals);
    console.log("📚 Learning data:", learning);
    
    // Get current profile
    const profileSnap = await getDoc(profileRef);
    const currentProfile = profileSnap.exists() ? profileSnap.data() : { uid };
    console.log("📄 Current profile:", currentProfile);
    
    // Merge new data into profile
    const updatedProfile = mergeGoalsIntoProfile(currentProfile, goals, learning);
    console.log("🔄 Updated profile:", updatedProfile);
    
    // Save with merge to preserve other fields
    await setDoc(profileRef, updatedProfile, { merge: true });
    
    console.log("✅ Goals and learning preferences saved successfully");
  } catch (error) {
    console.error("❌ Error saving goals:", error);
    console.error("❌ Error details:", {
      message: error instanceof Error ? error.message : 'Unknown error',
      stack: error instanceof Error ? error.stack : undefined,
      uid,
      goals,
      learning
    });
    throw error;
  }
}

